(function() {
    'use strict';

    function CopyrightController() {
        var vm = this;
        vm.currentYear = new Date().getFullYear();
    }

    angular.module('doclr.components.copyright', [])
        .directive('doclrCopyright', function () {
            return {
                restrict: 'A',
                template: '&copy; {{ vm.currentYear }} docleas.eu',
                controllerAs: 'vm',
                controller: CopyrightController
            };
            }
        );

})();